import { useEffect, useState } from "react";
import { Form, Row } from "react-bootstrap";
import { useFormContext, useWatch } from "react-hook-form";

import { api_without_cancellation } from "../../../../../api/api";

const CounselFileInformationFields = ({ entityId, pageName = null }) => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  const path = (field) => `counsel.${entityId}.${field}`;

  const counselTypeId = useWatch({ control, name: path("counsel_type_id") });

  const fieldError = errors?.counsel?.[entityId]?.counsel_type_id;
  const [counselTypes, setCounselTypes] = useState([]);

  const fetchCounselTypesData = async () => {
    try {
      const page = pageName || null;
      const response = await api_without_cancellation.get(
        `/api/defendants/counsel_types/?page=${page}`
      );
      if (response.status === 200) {
        setCounselTypes(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCounselTypesData();
  }, []);

  return (
    <>
      <Row className="custom-margin-bottom p-l-5 p-r-5 m-t-5 mx-0 position-relative">
        <span className="d-inline-block white-space-nowrapping text-grey align-self-center m-r-5 counsel-input-label">
          Counsel Type:
        </span>
        <div className="d-flex-1 custom-select-new-provider">
          <Form.Control
            as="select"
            className={`custom-margin-bottom height-25 p-0 p-l-5 rounded-0 mb-0 ${fieldError ? "is-invalid" : ""}`}
            {...register(path("counsel_type_id"), { required: "Counsel type is required" })}
            value={counselTypeId ?? ""}
          >
            <option value="" disabled>
              Select Counsel Type
            </option>
            {counselTypes?.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </Form.Control>
        </div>
      </Row>

      <Row className="custom-margin-bottom mx-0 p-l-5 p-r-5">
        <span className="d-inline-block white-space-nowrapping text-grey align-self-center m-r-5 counsel-input-label">
          File Number:
        </span>
        <div className="d-flex-1">
          <Form.Control
            type="text"
            placeholder="Enter File Number"
            className="form-control rounded-0 height-25"
            {...register(path("file_number"))}
          />
        </div>
      </Row>

      <Row className="custom-margin-bottom mx-0 p-l-5 p-r-5">
        <span className="d-inline-block white-space-nowrapping text-grey align-self-center m-r-5 counsel-input-label">
          Original Lien
        </span>
        <div className="d-flex-1">
          <Form.Control
            type="number"
            step="any"
            placeholder="Original Lien"
            className="height-25"
            {...register(path("orignal_lien"), {
              setValueAs: (v) => (v === "" || v === null ? null : parseFloat(v)),
            })}
          />
        </div>
      </Row>

      <Row className="custom-margin-bottom mx-0 p-l-5 p-r-5">
        <span className="d-inline-block white-space-nowrapping text-grey align-self-center m-r-5 counsel-input-label">
          Final Lien
        </span>
        <div className="d-flex-1">
          <Form.Control
            type="number"
            step="any"
            placeholder="Final Lien"
            className="height-25"
            {...register(path("final_lien"), {
              setValueAs: (v) => (v === "" || v === null ? null : parseFloat(v)),
            })}
          />
        </div>
      </Row>
    </>
  );
};

export default CounselFileInformationFields;
